<template>
  <div>
    <div>
      <el-row type="flex">
        <el-col :span="14">
          <el-table
            :header-cell-style="headerCellStyle"
            :border="true"
            :data="features"
          >
            <el-table-column
              type="index"
              label="STT"
              width="50"
              align="center"
            />

            <el-table-column
                label="Tên chức năng"
            >
              <template v-slot:default="scope">
                <span>{{scope.row.title}}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="Tác vụ"
              align="center"
              width="200"
            >
              <template v-slot:default="scope">
                <el-button
                    type="primary"
                    size="small"
                    @click="handleIsOpenDialog(scope.row.key)"
                >
                  {{scope.row.label_btn}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <!--   Dialog   -->
      <CreateAttendanceAndComments
        :is-open="isDialog.attendanceAndComments"
        @closeDialog="handleCloseDialog"
      />

      <CreateCommentsWeekAndMonth
        :is-open="isDialog.commentsWeekAndMonth"
        @closeDialog="handleCloseDialog"
      />

      <DeleteDataDuplicate
        :is-open="isDialog.deleteDataDuplicate"
        @closeDialog="handleCloseDialog"
      />

      <CreateQrCode
        :is-open="isDialog.createQrCode"
        @closeDialog="handleCloseDialog"
      />
    </div>
  </div>
</template>

<script>
import CreateAttendanceAndComments from "@/views/master/school/dialog/CreateAttendanceAndComments.vue";
import CreateCommentsWeekAndMonth from "@/views/master/school/dialog/CreateCommentsWeekAndMonth.vue";
import DeleteDataDuplicate from "@/views/master/school/dialog/DeleteDataDuplicate.vue";
import CreateQrCode from "@/views/master/school/dialog/CreateQrCode.vue";

const headerCellStyle = () => {
  return {
    backgroundColor: "#78a5e7",
    color: "#fff",
  }
}
export default {
  components: {CreateQrCode, DeleteDataDuplicate, CreateCommentsWeekAndMonth, CreateAttendanceAndComments},
  data() {
    return {
      features: [
        {
          key: "attendance_and_comments",
          title: "Tạo điểm danh/nhận xét",
          label_btn: "Khởi tạo"
        },
        {
          key: "comments_week_and_month",
          title: "Tạo nhận xét tuần/tháng",
          label_btn: "Khởi tạo"
        },
        {
          key: "delete_data_duplicate",
          title: "Xoá dữ liệu trùng lặp",
          label_btn: "Truy cập"
        },
        {
          key: "create_qr_code",
          title: "Tạo mã QR code",
          label_btn: "Khởi tạo"
        }
      ],
      isDialog: {
        attendanceAndComments: false,
        commentsWeekAndMonth: false,
        deleteDataDuplicate: false,
        createQrCode: false,
      }
    };
  },
  methods: {
    headerCellStyle,

    handleOpenDialogAttendanceAndComments() {
      this.isDialog.attendanceAndComments = true;
    },

    handleOpenDialogCommentsWeekAndMonth() {
      this.isDialog.commentsWeekAndMonth = true;
    },

    handleOpenDialogDeleteDataDuplicate() {
      this.isDialog.deleteDataDuplicate = true;
    },

    handleOpenDialogCreateQrCode() {
      this.isDialog.createQrCode = true;
    },

    handleIsOpenDialog(key) {
      switch (key) {
        case "attendance_and_comments":
          this.handleOpenDialogAttendanceAndComments();
          break;
        case "comments_week_and_month":
          this.handleOpenDialogCommentsWeekAndMonth();
          break;
        case "delete_data_duplicate":
          this.handleOpenDialogDeleteDataDuplicate();
          break;
        case "create_qr_code":
          this.handleOpenDialogCreateQrCode();
          break;
      }
    },

    handleCloseDialog(key) {
      switch (key) {
        case "attendance_and_comments":
          this.isDialog.attendanceAndComments = false;
          break;
        case "comments_week_and_month":
          this.isDialog.commentsWeekAndMonth = false;
          break;
        case "delete_data_duplicate":
          this.isDialog.deleteDataDuplicate = false;
          break;
        case "create_qr_code":
          this.isDialog.createQrCode = false;
          break;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
